import { all, put, takeEvery, takeLatest, call, select } from 'redux-saga/effects';
import * as t from '../action_types';
import * as actions from '../action_creators';
import { post_api, get_api, delete_api } from '../api_funcs';
import { get_api_url } from '../../utils/urls';

export function* getApprovedTeachers(action) {
  try {
    yield put(actions.set_teachers_variable('approved_teachers_status', 'loading'));
    const url = get_api_url('get_teachers_list_approved');
    const payload = {
      status: action.payload
    };
    const response = yield call(post_api, url, payload, true);
    yield put(actions.set_teachers_variable('approved_teachers_list', response.data.teachers));
    yield put(actions.set_teachers_variable('approved_teachers_status', 'success'));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(actions.log_out());
    }
    console.log('chat errpr is ', error);
  }
}

export function* getTeachersList() {
  try {
    yield put(actions.set_teachers_variable('teachers_list_status', 'loading'));
    const url = get_api_url('get_teachers_list');
    const response = yield call(post_api, url, null, true);
    const teachers = [...response.data.teachers];
    teachers.sort((a, b) => a.first_name.localeCompare(b.first_name));
    yield put(actions.filter_teachers('teachers_list', teachers));
    yield put(actions.set_teachers_variable('teachers_list_status', 'success'));
  } catch (error) {
    if (error.response?.status === 401) {
      yield put(actions.log_out());
    }
    console.log('chat errpr is ', error);
  }
}

export function* approveTeacherDetails(action) {
  yield;
}

export function* getTeacherProfileDetails(action) {
  try {
    yield put(actions.set_teachers_variable('teacher_profile_status', 'loading'));
    const url = get_api_url('get_teacher_details');
    const payload = {
      teacher_uuid: action.payload
    };
    const response = yield call(post_api, url, payload, true);
    yield put(actions.set_teachers_variable('teacher_profile_details', response.data.teacher));
    yield put(actions.set_teachers_variable('teacher_profile_status', 'success'));
  } catch (error) {
    yield put(actions.set_teachers_variable('teacher_profile_status', 'fail'));
    if (error.response.status === 401) {
      yield put(actions.log_out());
    }
  }
}

export function* updateTeacherFiles(action) {
  try {
    yield put(actions.set_teachers_variable('teacher_profile_status', 'loading'));
    let url;
    if (action.payload.key === 'photo') {
      url = get_api_url('update_teacher_photo');
    } else if (action.payload.key === 'resume') {
      url = get_api_url('upload_resume');
    } else if (action.payload.key === 'video') {
      url = get_api_url('update_video');
    }
    const data = new FormData();
    data.append(action.payload.key, action.payload.payload);
    data.append('teacher_uuid', action.payload.uuid);
    yield call(post_api, url, data, true, 'formdata');
    yield put(actions.get_teacher_profile_details(action.payload.uuid));
  } catch (error) {
    if (error.response.status === 401) {
      yield put(actions.log_out());
    }
  }
}

// Transcoding runs on the server after the upload lands, so this call outlives UPLOAD_TIMEOUT_MS.
const TRIAL_VIDEO_UPLOAD_TIMEOUT_MS = 300000;

// an upload or delete can finish after Care opened another teacher, whose page it must not change
const is_trial_video_page = (state, teacher_uuid) =>
  state.teachers.trial_video_teacher_uuid === teacher_uuid;

const trial_video_error = (error, fallback) => {
  const message = error?.response?.data?.message;
  return typeof message === 'string' && message ? message : fallback;
};

export function* getTrialTeacherVideo(action) {
  const teacher_uuid = action.payload;
  try {
    yield put(actions.set_teachers_variable('trial_video_teacher_uuid', teacher_uuid));
    yield put(actions.set_teachers_variable('trial_video_status', 'loading'));
    // clear the previous teacher's video so it never shows under this profile
    yield put(actions.set_teachers_variable('trial_video', null));
    const url = get_api_url(`/v2/trial_teacher_video/cms/teacher/${teacher_uuid}`, false, true);
    const response = yield call(get_api, url, true);
    yield put(actions.set_teachers_variable('trial_video', response.data.data.video));
    yield put(actions.set_teachers_variable('trial_video_status', 'success'));
  } catch (error) {
    yield put(actions.set_teachers_variable('trial_video_status', 'fail'));
    if (error.response?.status === 401) {
      yield put(actions.log_out());
    }
  }
}

export function* uploadTrialTeacherVideo(action) {
  const { teacher_uuid, file } = action.payload;
  try {
    yield put(actions.set_teachers_variable('trial_video_upload_teacher_uuid', teacher_uuid));
    yield put(actions.set_teachers_variable('trial_video_upload_status', 'loading'));
    const url = get_api_url('/v2/trial_teacher_video/cms/upload', false, true);
    const data = new FormData();
    data.append('teacher_uuid', teacher_uuid);
    data.append('file', file);
    const response = yield call(
      post_api,
      url,
      data,
      true,
      'formdata',
      TRIAL_VIDEO_UPLOAD_TIMEOUT_MS
    );
    if (yield select(is_trial_video_page, teacher_uuid)) {
      yield put(actions.set_teachers_variable('trial_video', response.data.data));
    }
    yield put(actions.set_teachers_variable('trial_video_upload_status', 'success'));
    yield put(actions.set_notification_variable(true, 'success', 'Trial welcome video uploaded'));
  } catch (error) {
    yield put(actions.set_teachers_variable('trial_video_upload_status', 'fail'));
    if (error.response?.status === 401) {
      yield put(actions.log_out());
      return;
    }
    yield put(
      actions.set_notification_variable(
        true,
        'error',
        trial_video_error(error, 'Could not upload the video')
      )
    );
  }
}

export function* deleteTrialTeacherVideo(action) {
  const teacher_uuid = action.payload;
  try {
    const url = get_api_url(
      `/v2/trial_teacher_video/cms/teacher/${teacher_uuid}/video`,
      false,
      true
    );
    yield call(delete_api, url, true);
    if (yield select(is_trial_video_page, teacher_uuid)) {
      yield put(actions.set_teachers_variable('trial_video', null));
    }
    yield put(actions.set_notification_variable(true, 'success', 'Trial welcome video deleted'));
  } catch (error) {
    if (error.response?.status === 401) {
      yield put(actions.log_out());
      return;
    }
    yield put(
      actions.set_notification_variable(
        true,
        'error',
        trial_video_error(error, 'Could not delete the video')
      )
    );
  }
}

export function* getTrialTeacherVideosList() {
  try {
    yield put(actions.set_teachers_variable('trial_videos_list_status', 'loading'));
    const url = get_api_url('/v2/trial_teacher_video/cms/list', false, true);
    const response = yield call(get_api, url, true);
    yield put(actions.set_teachers_variable('trial_videos_list', response.data.data.items));
    yield put(actions.set_teachers_variable('trial_videos_list_status', 'success'));
  } catch (error) {
    yield put(actions.set_teachers_variable('trial_videos_list_status', 'fail'));
    if (error.response?.status === 401) {
      yield put(actions.log_out());
    }
  }
}

export default function* chatSaga() {
  yield all([
    takeLatest(t.get_approved_teachers, getApprovedTeachers),
    takeEvery(t.approve_teacher_details, approveTeacherDetails),
    takeLatest(t.get_teacher_profile_details, getTeacherProfileDetails),
    takeLatest(t.update_teacher_files, updateTeacherFiles),
    takeLatest(t.get_teachers_list, getTeachersList),
    takeLatest(t.get_trial_teacher_video, getTrialTeacherVideo),
    takeLatest(t.upload_trial_teacher_video, uploadTrialTeacherVideo),
    takeLatest(t.delete_trial_teacher_video, deleteTrialTeacherVideo),
    takeLatest(t.get_trial_teacher_videos_list, getTrialTeacherVideosList)
  ]);
}
